// Insta360YoutubeEmbed.jsx
import React, { useState } from "react";

// Update this list as Parts 4 & 5 finish uploading:
const PARTS = [
  { title: "Memorial 360° – Part 1", id: "hwlhu72Gy1c" },
  { title: "Memorial 360° – Part 2", id: "LY2uBEpwzs0" }, // will work once processing finishes
  { title: "Memorial 360° – Part 3", id: "HT9GwSad61s" },
  // { title: "Memorial 360° – Part 4", id: "REPLACE_WITH_ID" },
  // { title: "Memorial 360° – Part 5", id: "REPLACE_WITH_ID" },
];

export default function Video360() {
  const [showVideo, setShowVideo] = useState(false);
  const [idx, setIdx] = useState(0);

  const current = PARTS[idx];
  const embedUrl = `https://www.youtube-nocookie.com/embed/${current.id}?rel=0&modestbranding=1&playsinline=1`;
  const watchUrl = `https://www.youtube.com/watch?v=${current.id}`;

  const next = () => setIdx((i) => Math.min(i + 1, PARTS.length - 1));
  const prev = () => setIdx((i) => Math.max(i - 1, 0));

  return (
    <div style={{ textAlign: "center", padding: 20 }}>
      {/* Match your shorter sidebar/page title */}
      <h2 style={{ color: "#8e44ad", fontWeight: "bold" }}>Memorial 360°</h2>

      {!showVideo ? (
        <div
          style={{
            backgroundColor: "#fdf1f8",
            border: "2px solid #d6a5d6",
            borderRadius: 12,
            padding: 20,
            maxWidth: 700,
            margin: "20px auto",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            lineHeight: 1.6,
            color: "#5a2d82",
            textAlign: "left",
          }}
        >
          <h3 style={{ marginBottom: 10, color: "#a03da3" }}>Trigger Warning</h3>
          <p>
            This 360° memorial video contains emotional scenes of grieving family and friends.
            While there is no full view of Theyda, certain angles may show a small portion of her.
            Please take care of yourself as you watch, and feel free to skip if it may be too difficult.
          </p>

          <div style={{ textAlign: "center", marginTop: 15 }}>
            <button
              onClick={() => setShowVideo(true)}
              style={primaryBtn}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#8e44ad")}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#a03da3")}
            >
              Continue to Videos
            </button>
          </div>
        </div>
      ) : (
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          {/* Controls row */}
          <div style={controlsRow}>
            <button onClick={prev} disabled={idx === 0} style={navBtn(idx === 0)}>
              ◀︎ Previous
            </button>

            <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ color: "#7c53c3", fontWeight: 700 }}>Select part:</span>
              <select
                value={idx}
                onChange={(e) => setIdx(Number(e.target.value))}
                style={selectStyle}
                aria-label="Select video part"
              >
                {PARTS.map((p, i) => (
                  <option key={p.id} value={i}>
                    {p.title}
                  </option>
                ))}
              </select>
            </label>

            <button onClick={next} disabled={idx === PARTS.length - 1} style={navBtn(idx === PARTS.length - 1)}>
              Next ▶︎
            </button>
          </div>

          {/* Title */}
          <h3 style={{ color: "#7c53c3", margin: "8px 0 12px 0", fontWeight: 800, fontFamily: "Montserrat, Arial, sans-serif" }}>
            {current.title}
          </h3>

          {/* Player */}
          <div
            style={{
              position: "relative",
              paddingBottom: "56.25%",
              height: 0,
              overflow: "hidden",
              borderRadius: 12,
              boxShadow: "0 3px 18px rgba(80,64,120,0.13)",
            }}
          >
            <iframe
              title={current.title}
              src={embedUrl}
              allow="accelerometer; gyroscope; encrypted-media; fullscreen; picture-in-picture"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
              style={{ position: "absolute", inset: 0, width: "100%", height: "100%", border: 0, borderRadius: 12 }}
            />
          </div>

          {/* Open on YouTube */}
          <div style={{ marginTop: 8 }}>
            <a href={watchUrl} target="_blank" rel="noopener noreferrer" className="video-open-link">
              Open on YouTube (fullscreen)
            </a>
          </div>

          {/* Bottom controls duplicate (handy on mobile) */}
          <div style={{ ...controlsRow, marginTop: 16 }}>
            <button onClick={prev} disabled={idx === 0} style={navBtn(idx === 0)}>
              ◀︎ Previous
            </button>
            <button onClick={next} disabled={idx === PARTS.length - 1} style={navBtn(idx === PARTS.length - 1)}>
              Next ▶︎
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

/* ---------- tiny style helpers (inline to keep this self-contained) ---------- */
const primaryBtn = {
  backgroundColor: "#a03da3",
  color: "white",
  padding: "10px 20px",
  fontSize: "1rem",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  transition: "background-color 0.2s ease",
  fontWeight: 700,
};

const controlsRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 12,
  margin: "0 auto 8px",
  maxWidth: 900,
  flexWrap: "wrap",
};

const selectStyle = {
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
  background: "#f7f4ff",
  border: "1.5px solid #d1c4e9",
  borderRadius: 10,
  padding: "10px 12px",
  fontSize: "0.98rem",
  color: "#5a2d82",
  fontWeight: 600,
  boxShadow: "0 2px 10px #e9e1f5",
};

const navBtn = (disabled) => ({
  background: disabled ? "#eee9ff" : "#f7f4ff",
  color: disabled ? "#b7a7ea" : "#7745d6",
  fontWeight: 700,
  border: "none",
  borderRadius: 10,
  padding: "10px 14px",
  cursor: disabled ? "not-allowed" : "pointer",
  boxShadow: "0 2px 10px #e9e1f5",
});
